import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const RugbyUnionIcon = observer('RugbyUnionIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M3.76369 19.4734C5.13869 16.713 6.68027 14.2819 8.38885 12.1807L7.6999 11.4631C7.5444 11.3011 7.54964 11.0438 7.7116 10.8883C7.87364 10.7328 8.13094 10.738 8.28643 10.9L8.91296 11.5525C9.23635 11.1749 9.5655 10.8087 9.90041 10.4538L9.31693 9.84601C9.16144 9.68405 9.16676 9.42667 9.32872 9.27117C9.49067 9.11567 9.74806 9.12091 9.90355 9.28296L10.467 9.86984L10.4919 9.84487C10.8309 9.50594 11.1781 9.17557 11.5337 8.85366L10.9341 8.22897C10.7786 8.06701 10.7838 7.80963 10.9458 7.65413C11.1077 7.49864 11.3651 7.50387 11.5206 7.66583L12.1447 8.31593C14.2844 6.48535 16.7118 4.94581 19.4257 3.69751C16.8308 2.04216 10.7202 3.40161 7.0721 7.0497C3.36419 10.7576 2.00127 16.8975 3.76369 19.4734Z'
                fill='fill'
            />
            <path
                d='M20.0948 4.28685C17.3298 5.52341 14.8681 7.06225 12.7088 8.90351L13.5904 9.82191C13.7459 9.98395 13.7407 10.2413 13.5787 10.3967C13.4167 10.5522 13.1594 10.547 13.0039 10.385L12.0971 9.44046C11.7452 9.75844 11.4018 10.0849 11.0669 10.4198L11.0302 10.4566L11.9734 11.439C12.1289 11.601 12.1236 11.8584 11.9617 12.0139C11.7996 12.1694 11.5423 12.1641 11.3868 12.0021L10.4642 11.0411C10.13 11.3963 9.80149 11.7632 9.4788 12.142L10.3563 13.0561C10.5118 13.218 10.5066 13.4754 10.3445 13.6309C10.1826 13.7864 9.92521 13.7812 9.76971 13.6192L8.95635 12.7719C7.25587 14.8767 5.72221 17.3227 4.35575 20.1106C6.82091 22.0595 13.1576 20.7202 16.9501 16.9277C20.7405 13.1373 22.0602 6.6885 20.0948 4.28685Z'
                fill='fill'
            />
        </SvgElement>
    );
});
